module.exports = __webpack_public_path__ + "img/logo_patrocinadores.170a8462.png";